import store from "@/store";

export function getReferenceDataDescription(
  value: any,
  referenceDataType: any
) {
  let description = "" as any;
  const referenceData = store.state.referenceData.data;

  if (value && referenceData && Object.keys(referenceData).length > 0) {
    description =
      (
        referenceData[referenceDataType].items.find(
          (v: any) => v.id && v.id.toString() === value
        ) || ({} as any)
      ).description || "";
  }

  return description;
}
